import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'sm-page-size',
	template: require('./sm-page-size.component.html')
})
export class SmPageSizeComponent {
	@Input() pageSize: number = 25;
	@Input() pageSizes: number[] = [25, 50, 100];
	@Output() onChange: EventEmitter<number> = new EventEmitter();

	changePageSize(newPageSize: number) {
		if (this.pageSize != newPageSize) {
			if (this.onChange) {
				this.onChange.emit(newPageSize);
			}
			this.pageSize = newPageSize;
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-page-size.component.ts